// extracted by mini-css-extract-plugin
export default {"breadcrumb":"jj-z","breadcrumbItem":"kj-z","hideOnMobile":"lj-z"};